import {Component, OnInit} from '@angular/core';
import { ProjectFinancialService } from '../../../../services/projectFinancial.service';
import { TeamGroupsService } from '../../../../services/teamGroups.service';
import { Consultant } from '../../../../models/Consultant.model';
import { TeamGroups } from '../../../../models/teamGroups.model';
import { ErrorHandlerProvider } from '../../../../shared/providers/errorHandler.provider';
import { ToastsManager } from 'ng2-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

@Component({
    selector: 'app-consultants-teamGroups-edit',
    templateUrl: './consultants-teamGroups-edit.component.html',
    styleUrls: ['./consultants-teamGroups-edit.component.css']
})
export class ConsultantsTeamGroupsEditComponent implements OnInit {
    loading: boolean;
    dropDownTeamGroups: any;
    teamGroupForm: FormGroup;
    dropDownProjects: any;
    consultantGroups: TeamGroups = new TeamGroups();
    dropDownConsultant: any;
    consultantsLoad: Consultant[] = new Array<Consultant>();
    teamGroupsSearch: any;

    constructor(
        private projectsFinancial: ProjectFinancialService,
        private teamGroupsService: TeamGroupsService,
        private errorHandler: ErrorHandlerProvider,
        private toastr: ToastsManager,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
        private router: Router
    ) {}

    async ngOnInit() {
        this.loading = true;
        this.teamGroupForm = this.formBuilder.group({
            name: [null, Validators.required],
        });
        this.consultantGroups = await this.teamGroupsService.getById(this.route.snapshot.params['id']);
        await this.populateConsultants();
        this.loading = false;
    }

    async Edit() {
        if(this.consultantGroups.consultants.length > 0){
            try {
                let response = await this.teamGroupsService.update(this.consultantGroups);
                if (response._id) {
                    this.toastr.success('Grupo de times atualizado com sucesso!');
                    this.router.navigate(['/consultants/teamGroups']);
                } else {
                    this.errorHandler.interceptError(response, 'Grupo de Time');
                }
            } catch (err) {
                this.errorHandler.interceptError(err, 'Grupo de Time');
            }
        }
    }

    async populateConsultants() {
        this.consultantsLoad = await this.projectsFinancial.getAllConsultants();
        this.dropDownConsultant = await this.projectsFinancial.createPropertyObjDropDown(this.consultantsLoad, false, "Consultores", "consultores");
    }

    addItem() {
        if(this.dropDownConsultant.selectedItems.length > 0 ) {
            const selectedConsultant = this.dropDownConsultant.selectedItems[0];

            let veriftConsultants =  this.consultantGroups.consultants.findIndex(item => item._id == selectedConsultant.id)

            if( veriftConsultants === -1 ){
                this.consultantGroups.consultants.push({
                    name: selectedConsultant.itemName,
                    _id: selectedConsultant.id
                });

                this.sortConsultant();
            }

            this.dropDownConsultant.selectedItems = []
        }
    }

    sortConsultant() {
        this.consultantGroups.consultants.sort((a, b) => {
            if(a.name > b.name) return 1;
            if(a.name < b.name) return -1;
            return 0;
        })
    }

    removeItem(i) {
        this.consultantGroups.consultants.splice(i, 1);
    }

    verifyValidTouched(fieldName) {
        return !this.teamGroupForm.get(fieldName).valid && this.teamGroupForm.get(fieldName).touched;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/views/consultants/consultants-teamGroups/consultants-teamGroups-edit/consultants-teamGroups-edit.component.ts